<template>
  <div class="title ljb-big-title flex ljb-double_center">
    {{ moduleTitle.title }}
    <span
      v-show="moduleTitle.text"
      class="text">{{ moduleTitle.text }}</span>
  </div>
</template>
<script>
export default {
  name: 'ModuleTitle',
  props: {
    moduleTitle: {
      type: Object,
      default: function () {
        return ''
      }
    }
  }

}
</script>

<style lang="scss" scoped>
  .title{
    margin-top: $margin;
    padding:  $padding;
    .text{
      margin-left: 10px;
      font-size: 12px;
      color: #aaa;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/title/ModuleTitle.vue